import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetLoginState } from "app/redux";
import CustomToolTip from "./CustomToolTip";
import LogoutConfirmDialog from "./LogoutConfirmDialog";
import { ContactProfileDetailsContext } from "../macrocomponents/ContactLayout";

function SignoutLeftPanel() {
  const { isOpen } = useContext(ContactProfileDetailsContext);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(resetLoginState());
    navigate("/");
  };

  return (
    <>
      <LogoutConfirmDialog
        popUpOpen={popUpOpen}
        setPopUpOpen={setPopUpOpen}
        logoutHandle={logOut}
      />
      <div
        className={`flex  p-2 mt-2  gap-2 items-center justify-center ${
          isOpen ? "flex-row" : "flex-col"
        } hover:cursor-pointer relative group`}
        onClick={() => setPopUpOpen(true)}
      >
        <i className={`pi pi-sign-out ${isOpen ? "" : "mb-2"}`} style={{ fontSize: "1rem" }} />
        <span
          className={`text-sm font-semibold ${
            isOpen ? "w-20" : "w-0 p-0 hidden"
          } transition-all overflow-hidden`}
        >
          Sign Out
        </span>
        {!isOpen && <CustomToolTip text="Sign out" />}
      </div>
    </>
  );
}

export default SignoutLeftPanel;
